import styled from "styled-components";
import { Card, Button, Steps } from "antd";

export const Stepper = styled(Steps)`
  .ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-icon {
    background: white !important;
    
    .ant-steps-icon {
      color: #db0008 !important;
    }
  }

  .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
    background: white !important;

    .ant-steps-icon {
      color: #db0008 !important;
    }
  }

  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-icon {
    background: #db0008 !important;

    .ant-steps-icon {
      color: white !important;
    }
  }
  
  .ant-steps-item-wait .ant-steps-item-icon {
    border-color: #db0008 !important;
  }
  .ant-steps-item-process .ant-steps-item-icon {
    border-color: #db0008 !important;
  }
  .ant-steps-item-finish .ant-steps-item-icon {
    border-color: white !important;
  }

  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after {
    background-color: #db0008 !important;
  }
`;

export const QuestionBox = styled.div`
  display: flex;
  flex-direction: row;
  padding: 30px;
  width: 100%;
  align-items: end;
`;

export const CostView = styled.div`
  font-size: 20px;
  font-weight: 600;
  margin: auto;
  background-color: #c52028;
  color: white;
  width: 180px;
  height: 50px;
  border-radius: 7px;
  text-align: center;
  padding-top: 9px;
`;